module.exports = __webpack_public_path__ + "img/access-denied.99e2f275.svg";